import { render, staticRenderFns } from "./projectManagement.vue?vue&type=template&id=26539bec&scoped=true"
import script from "./projectManagement.vue?vue&type=script&lang=js"
export * from "./projectManagement.vue?vue&type=script&lang=js"
import style0 from "./projectManagement.vue?vue&type=style&index=0&id=26539bec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26539bec",
  null
  
)

export default component.exports